function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationCarSideFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 19.5h-2.351a3.495 3.495 0 00-3.149-2 3.493 3.493 0 00-3.148 2h-7.703a3.495 3.495 0 00-3.149-2 3.493 3.493 0 00-3.148 2H4v-4h24v4zm-5.5 3a1.497 1.497 0 01-1.408-1A1.483 1.483 0 0121 21c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .176-.036.343-.092.5-.207.581-.757 1-1.408 1zm-14 0a1.497 1.497 0 01-1.408-1A1.483 1.483 0 017 21c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .176-.036.343-.092.5-.207.581-.757 1-1.408 1zm4.035-13H18v2.055h2V9.5h2.279l1.333 4H9.868l2.667-4zM29 13.5h-3.279l-1.773-5.316A.997.997 0 0023 7.5H12c-.334 0-.646.167-.832.445L7.465 13.5H3a1 1 0 00-1 1v6a1 1 0 001 1h2.051c.245 1.692 1.69 3 3.449 3s3.204-1.308 3.449-3h7.102c.245 1.692 1.69 3 3.449 3s3.204-1.308 3.449-3H29a1 1 0 001-1v-6a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconTransportationCarSideFilled;